import React from 'react'

import style from './ConfirmModal.module.css'

import { BasicModal, Button } from 'common/components'
import { useKeyDown } from 'common/hooks'

type PropsType = {
  title: string
  isOpen: boolean
  message: string
  onClose: Function
  callback: Function
}

export const ConfirmModal = ({ title, isOpen, onClose, message, callback }: PropsType) => {
  const confirmButtonHandler = () => {
    if (isOpen) {
      callback()
    }

    onClose()
  }

  useKeyDown(confirmButtonHandler, 'Enter')

  return (
    <BasicModal title={title} isOpen={isOpen} onClose={onClose}>
      <div className={style.content}>
        <p className={style.message}>{message}</p>
        <div className={style['button-box']}>
          <Button accent={true} onClick={() => onClose()}>
            Нет
          </Button>

          <Button onClick={confirmButtonHandler} autoFocus>
            Да
          </Button>
        </div>
      </div>
    </BasicModal>
  )
}
